import React from 'react';

import Box from '@amzn/meridian/box';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { TextColor } from '@amzn/meridian/text/text';

interface IRowTag {
    searchType: string;
    width: string | undefined;
    colorClass: string;
}

export const RowTag: React.FC<IRowTag> = (props) => {
    return (
        <Text type={'b200'}>
            <Box width={props.width} type={'outline'} spacingInset={'100'} className={props.colorClass}>
                <Row alignmentHorizontal={'center'}>
                    <Text color={'primary'}>{props.searchType}</Text>
                </Row>
            </Box>
        </Text>
    );
};
